import axios from 'axios'
import CognitoService from '@/services/CognitoService.js'

//dev
// axios.defaults.baseURL =
// 	'https://k0hu0vcwr8.execute-api.ap-southeast-2.amazonaws.com/dev'

//prod
axios.defaults.baseURL =
	'https://bnhrhq74q4.execute-api.ap-southeast-2.amazonaws.com/prod'

export default {
	async getJobs(job_status, query_type, pageSize, sortBy, exclusiveStartKey) {
		// axios.defaults.headers.common.Authorization = `Bearer ${token}`
		await CognitoService.checkTokenExpire()
		const token = sessionStorage.getItem('token')
		return axios.get(
			`/jobs/jobStatus/${job_status}/queryType/${query_type}/pageSize/${pageSize}/sortBy/${sortBy}/exclusiveStartKey/${exclusiveStartKey}`,
			{
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		)
	},

	async searchJobsByClientEmail(
		client_email,
		job_status,
		query_type,
		pageSize,
		sortBy,
		exclusiveStartKey
	) {
		await CognitoService.checkTokenExpire()
		const token = sessionStorage.getItem('token')
		return axios.get(
			`/jobs/clientEmail/${client_email}/jobStatus/${job_status}/queryType/${query_type}/pageSize/${pageSize}/sortBy/${sortBy}/exclusiveStartKey/${exclusiveStartKey}`,
			{
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		)
	},

	async searchJobsByBookingNumber(
		booking_number,
		job_status,
		query_type,
		pageSize,
		sortBy,
		exclusiveStartKey
	) {
		await CognitoService.checkTokenExpire()
		const token = sessionStorage.getItem('token')
		return axios.get(
			`/jobs/bookingNumber/${booking_number}/jobStatus/${job_status}/queryType/${query_type}/pageSize/${pageSize}/sortBy/${sortBy}/exclusiveStartKey/${exclusiveStartKey}`,
			{
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		)
	},

	async searchJobsByJobTitle(
		job_title,
		job_status,
		query_type,
		pageSize,
		sortBy,
		exclusiveStartKey
	) {
		await CognitoService.checkTokenExpire()
		const token = sessionStorage.getItem('token')
		return axios.get(
			`/jobs/jobTitle/${job_title}/jobStatus/${job_status}/queryType/${query_type}/pageSize/${pageSize}/sortBy/${sortBy}/exclusiveStartKey/${exclusiveStartKey}`,
			{
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		)
	},

	async getReport(beginDate, endDate) {
		await CognitoService.checkTokenExpire()
		const token = sessionStorage.getItem('token')
		return axios.get(
			`/jobs/report/beginDate/${beginDate}/endDate/${endDate}`,
			{
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		)
	},

	async createJob(job) {
		await CognitoService.checkTokenExpire()
		const token = sessionStorage.getItem('token')
		return axios.post(`/jobs/createJob`, job, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		})
	},

	async acceptJob(job_id, staff_name, staff_email, job_status) {
		await CognitoService.checkTokenExpire()
		const token = sessionStorage.getItem('token')
		const jobAttributes = {
			job_id,
			staff_name,
			staff_email,
			job_status
		}

		return axios.put('/jobs/acceptJob', jobAttributes, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		})
	},

	async completeJob(job_id) {
		await CognitoService.checkTokenExpire()
		const token = sessionStorage.getItem('token')
		const jobAttributes = {
			job_id
		}

		return axios.put('/jobs/completeJob', jobAttributes, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		})
	},

	async approveJob(job_id) {
		await CognitoService.checkTokenExpire()
		const token = sessionStorage.getItem('token')
		const jobAttributes = {
			job_id
		}

		return axios.put('/jobs/approveJob', jobAttributes, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		})
	},

	async addUnreadStaffPost(job_id) {
		await CognitoService.checkTokenExpire()
		const token = sessionStorage.getItem('token')
		return axios.put(
			'/jobs/addUnreadStaffPost',
			{ job_id },
			{
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		)
	},

	async addUnreadClientPost(job_id) {
		await CognitoService.checkTokenExpire()
		const token = sessionStorage.getItem('token')
		return axios.put(
			'/jobs/addUnreadClientPost',
			{ job_id },
			{
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		)
	},

	async clearUnreadClientPost(job_id) {
		await CognitoService.checkTokenExpire()
		const token = sessionStorage.getItem('token')
		return axios.put(
			'/jobs/clearUnreadClientPost',
			{ job_id },
			{
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		)
	},

	async clearUnreadStaffPost(job_id) {
		await CognitoService.checkTokenExpire()
		const token = sessionStorage.getItem('token')
		return axios.put(
			'/jobs/clearUnreadStaffPost',
			{ job_id },
			{
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		)
	},

	async getJob(job_id) {
		await CognitoService.checkTokenExpire()
		const token = sessionStorage.getItem('token')

		return axios.get(`/jobs/getJob/${job_id}`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		})
	},

	async getJobsParams(bookingNumber) {
		console.log(bookingNumber)
		await CognitoService.checkTokenExpire()
		const token = sessionStorage.getItem('token')
		return axios.get(`/bookingNumber/bookingNumber/${bookingNumber}`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		})
	}
}
